import { api } from './client';

export type BackendPaymentIntentStatus =
  | 'PENDING'
  | 'FARMER_CONFIRMED'
  | 'PAID'
  | 'WAITING_HTX_CONFIRMATION'
  | 'SETTLED'
  | 'RECONCILE_FAILED'
  | 'EXPIRED'
  | 'FAILED'
  | 'CANCELLED'
  | 'COMPLAINT';

export interface BackendPaymentIntent {
  _id: string;
  subjectRef: string;
  farmerId?: string;
  loanId?: string;
  amountVnd: string;
  /** Only set for a loan-repayment intent — the server-authoritative
   * breakdown of amountVnd (principal + accrued interest at creation time).
   * Never trust a client-computed figure over this. */
  principalVnd?: string;
  interestVnd?: string;
  interestRatePercentPerYear?: number;
  status: BackendPaymentIntentStatus;
  vietQrReconciliationCode: string;
  expiresAt: string;
  matchedBankTxnId?: string;
  farmerConfirmedAt?: string;
  htxConfirmedBy?: string;
  htxConfirmedAt?: string;
  settledAt?: string;
  cancelledAt?: string;
  cancelReason?: string;
  complaintAt?: string;
  complaintReason?: string;
  reconcileError?: string;
}

export interface CreatePaymentIntentPayload {
  subjectRef: string;
  amountVnd: number;
  farmerId?: string;
  loanId?: string;
  ttlMinutes?: number;
}

export async function createPaymentIntent(data: CreatePaymentIntentPayload): Promise<BackendPaymentIntent> {
  return api.post<BackendPaymentIntent>('/payments/intents', data);
}

export async function confirmTransfer(intentId: string, farmerId: string): Promise<BackendPaymentIntent> {
  return api.post<BackendPaymentIntent>(`/payments/intents/${intentId}/confirm-transfer`, { farmerId });
}

export async function htxManualConfirm(intentId: string): Promise<BackendPaymentIntent> {
  return api.post<BackendPaymentIntent>(`/payments/intents/${intentId}/htx-confirm`);
}

export async function filePaymentComplaint(intentId: string, reason: string): Promise<BackendPaymentIntent> {
  return api.post<BackendPaymentIntent>(`/payments/intents/${intentId}/complaint`, { reason });
}

export async function cancelPaymentIntent(intentId: string, reason?: string): Promise<BackendPaymentIntent> {
  return api.post<BackendPaymentIntent>(`/payments/intents/${intentId}/cancel`, { reason });
}

export async function listPaymentIntentsByFarmer(farmerId: string): Promise<BackendPaymentIntent[]> {
  return api.get<BackendPaymentIntent[]>(`/payments/farmers/${farmerId}`);
}
